import { createAsyncThunk } from '@reduxjs/toolkit';

// A small, self-contained thunk used only for the live keyword-search dropdown
// in the Topbar. It intentionally does NOT touch SearchPage's own Redux state,
// so typing here never overwrites the results shown on an already-loaded
// search results page.
export const searchKeywordSuggestions = createAsyncThunk(
  'TopbarSearchForm/searchKeywordSuggestions',
  async ({ keywords, perPage = 6 }, thunkAPI) => {
    const sdk = thunkAPI.extra;
    const response = await sdk.listings.query({
      keywords,
      perPage,
      'fields.listing': ['title'],
    });
    return response.data.data;
  }
);
